import { render } from "./alert_report.vue?vue&type=template&id=a4a419a6&scoped=true"
import script from "./alert_report.js?vue&type=script&lang=js"
export * from "./alert_report.js?vue&type=script&lang=js"

import "./alert_report.vue?vue&type=style&index=0&id=a4a419a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a419a6"]])

export default __exports__